import React from "react";
import { Grid } from "@material-ui/core";
import AccordionEtapa from "./AccordionEtapa";

export default function CronogramaSection({ etapas }) {
  if (etapas.loading || etapas.error) return null;

  return (
    <Grid container spacing={2}>
      {etapas.payload.map((item, key) => (
        <Grid item xs={12} key={key}>
          <AccordionEtapa title={item.descricao} etapa={item} />
        </Grid>
      ))}
    </Grid>
  );
}
